import { AppLink, asCurrency, asDate, asTimelessDate, colors, Tile, TileField } from 'lqx-react';
import * as React from 'react';
import { Transaction, TransactionStatusEnum } from 'src/app/pages/inmatch/api';
import { CustomerSupplier } from '../../../../../../common/inmatch';

export const ArPaymentTile = ({ transaction, style } : { 
        transaction : Transaction,
        style
    }) => {

        const status = transaction.status;

        const color =
            status === TransactionStatusEnum.Reconciled ? colors.green :
            status === TransactionStatusEnum.Unreconciled ? colors.orange :
            colors.yellow;

        return (
            <Tile
                style={style}
                color={color}
                leftTitle="AR"
                left={<TileField> { status } </TileField>}
                title={asCurrency(transaction.amount, transaction.currency)}
                aboveTitle={<CustomerSupplier customer={ transaction.customer } supplier={ transaction.supplier } payorAgent={ transaction.payorAgent } />}
            >
                <TileField label="Value Date">
                    {asTimelessDate(transaction.valueDate)}
                </TileField>

                <TileField label="Outstanding Amount">
                    {asCurrency(transaction.unreconciledAmount, transaction.currency)}
                </TileField>

                { !transaction.isOneSided &&
                    <TileField>
                        <AppLink href={`/bank-transactions/details/${transaction.id}`} returnUrl>View Details</AppLink>
                    </TileField>
                }
            </Tile>
        )
    }